
// src/actions/account.js

import api from './gamba-api'
import { emitAlertMessage, clearAlertMessage } from './alert-message'
import filter from 'lodash/filter'

export const FETCH_USERS_LENGTH = 99999999

export const FETCH_ACCOUNT_MEMBERS = "FETCH_ACCOUNT_MEMBERS"
export const FETCH_ACCOUNT_MEMBERS_REQUESTED = "FETCH_ACCOUNT_MEMBERS_REQUESTED"
export const FETCH_ACCOUNT_MEMBERS_COMPLETED = "FETCH_ACCOUNT_MEMBERS_COMPLETED"
export const FETCH_ACCOUNT_MEMBERS_FAILED = "FETCH_ACCOUNT_MEMBERS_FAILED"

export function fetchAccountMembersRequested() {
  return {
    type: FETCH_ACCOUNT_MEMBERS_REQUESTED,
  }
}

export function fetchAccountMembers(offset, query = undefined) {
  return function(dispatch) {
    dispatch(fetchAccountMembersRequested())
    return api.get(`/account/members`, { offset, query, length: FETCH_USERS_LENGTH })
        .then((results)=> {
          dispatch(fetchAccountMembersCompleted(results, offset))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchAccountMembersFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchAccountMembersCompleted(results, offset) {
  return {
    type: FETCH_ACCOUNT_MEMBERS_COMPLETED,
    results, offset
  }
}

export function fetchAccountMembersFailed(error) {
  return {
    type: FETCH_ACCOUNT_MEMBERS_FAILED,
    error,
  }
}

export const FETCH_MENTION_TO_USERS = "FETCH_MENTION_TO_USERS"
export const FETCH_MENTION_TO_USERS_REQUESTED = "FETCH_MENTION_TO_USERS_REQUESTED"
export const FETCH_MENTION_TO_USERS_COMPLETED = "FETCH_MENTION_TO_USERS_COMPLETED"
export const FETCH_MENTION_TO_USERS_FAILED = "FETCH_MENTION_TO_USERS_FAILED"

export function fetchMentionToUsersRequested() {
  return {
    type: FETCH_MENTION_TO_USERS_REQUESTED,
  }
}

export function fetchMentionToUsers(offset, mention_group_id, mentions_ids, query = undefined) {
  return function(dispatch) {
    dispatch(fetchMentionToUsersRequested())
    return api.get(`/account/members`, { offset, query, mention_group_id, mentions_ids, length: FETCH_USERS_LENGTH })
        .then((results)=> {
          dispatch(fetchMentionToUsersCompleted(results, offset))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchMentionToUsersFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchMentionToUsersCompleted(results, offset) {
  return {
    type: FETCH_MENTION_TO_USERS_COMPLETED,
    results, offset
  }
}

export function fetchMentionToUsersFailed(error) {
  return {
    type: FETCH_MENTION_TO_USERS_FAILED,
    error,
  }
}

export const FETCH_OTHER_MEMBERS = "FETCH_OTHER_MEMBERS"
export const FETCH_OTHER_MEMBERS_REQUESTED = "FETCH_OTHER_MEMBERS_REQUESTED"
export const FETCH_OTHER_MEMBERS_COMPLETED = "FETCH_OTHER_MEMBERS_COMPLETED"
export const FETCH_OTHER_MEMBERS_FAILED = "FETCH_OTHER_MEMBERS_FAILED"

export function fetchOtherMembersRequested() {
  return {
    type: FETCH_OTHER_MEMBERS_REQUESTED,
  }
}

export function fetchOtherMembers(offset, exclude_group_id, query = undefined) {
  return function(dispatch) {
    dispatch(fetchOtherMembersRequested())
    return api.get(`/account/members`, { offset, query, exclude_group_id, length: FETCH_USERS_LENGTH })
        .then((results)=> {
          dispatch(fetchOtherMembersCompleted(results, offset))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchOtherMembersFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchOtherMembersCompleted(results, offset) {
  return {
    type: FETCH_OTHER_MEMBERS_COMPLETED,
    results, offset
  }
}

export function fetchOtherMembersFailed(error) {
  return {
    type: FETCH_OTHER_MEMBERS_FAILED,
    error,
  }
}

export const CLEAR_FETCHED_USERS = "CLEAR_FETCHED_USERS"

export function clearFetchedUsers() {
  return {
    type: CLEAR_FETCHED_USERS
  }
}

export const FETCH_GROUP_MEMBERS_USERS = "FETCH_GROUP_MEMBERS_USERS"

export function fetchGroupMembersUsers(members, query) {
  return {
    type: FETCH_GROUP_MEMBERS_USERS,
    users: query && filter(members, (member)=> member.name.match(query) || member.email.match(query)) || members,
  }
}

export const FETCH_OTHER_MEMBERS_COUNT = "FETCH_OTHER_MEMBERS_COUNT"
export const FETCH_OTHER_MEMBERS_COUNT_REQUESTED = "FETCH_OTHER_MEMBERS_COUNT_REQUESTED"
export const FETCH_OTHER_MEMBERS_COUNT_COMPLETED = "FETCH_OTHER_MEMBERS_COUNT_COMPLETED"
export const FETCH_OTHER_MEMBERS_COUNT_FAILED = "FETCH_OTHER_MEMBERS_COUNT_FAILED"

export function fetchOtherMembersCountRequested() {
  return {
    type: FETCH_OTHER_MEMBERS_COUNT_REQUESTED,
  }
}

export function fetchOtherMembersCount(exclude_group_id) {
  return function(dispatch) {
    dispatch(fetchOtherMembersCountRequested())
    return api.get(`/account/members`, { offset: 0, exclude_group_id, length: 1 })
        .then((results)=> {
          dispatch(fetchOtherMembersCountCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchOtherMembersCountFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchOtherMembersCountCompleted(results) {
  return {
    type: FETCH_OTHER_MEMBERS_COUNT_COMPLETED,
    results,
  }
}

export function fetchOtherMembersCountFailed(error) {
  return {
    type: FETCH_OTHER_MEMBERS_COUNT_FAILED,
    error,
  }
}

export const FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS = "FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS"
export const FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_REQUESTED = "FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_REQUESTED"
export const FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_COMPLETED = "FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_COMPLETED"
export const FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_FAILED = "FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_FAILED"

export function fetchGroupMembersOnlyResignedMembersRequested() {
  return {
    type: FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_REQUESTED,
  }
}

export function fetchGroupMembersOnlyResignedMembers(offset, group_id, query = undefined) {
  return function(dispatch) {
    dispatch(fetchGroupMembersOnlyResignedMembersRequested())
    return api.get(`/groups/${group_id}/members`, { offset, query, length: FETCH_USERS_LENGTH, only_resigned_members: true })
        .then((results)=> {
          dispatch(fetchGroupMembersOnlyResignedMembersCompleted(results, offset))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchGroupMembersOnlyResignedMembersFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchGroupMembersOnlyResignedMembersCompleted(results, offset) {
  return {
    type: FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_COMPLETED,
    results, offset,
  }
}

export function fetchGroupMembersOnlyResignedMembersFailed(error) {
  return {
    type: FETCH_GROUP_MEMBERS_ONLY_RESIGNED_MEMBERS_FAILED,
    error,
  }
}



// WEBPACK FOOTER //
// ./src/actions/account.js